import Session from './Session.js';

export const validateEmail = (input) => {
        if (!input) {
                Session.alert('Email address is empty. Please provide a valid email address');
                return;
        }
        const res = input.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
        if (!res) Session.alert('Email address is not valid');
};


export const validatePassword = (password, confirmPassword) => {

        if (!password || password === '') {
                Session.alert('Password is empty. Please enter a password');
                return;
        }
        if (password.length < 7) {
                Session.alert('Password must have a minimum of 7 characters');
                return;
        }
        if (password !== confirmPassword) {
                Session.alert('Password field and confirm password field are not the same. Please use te same password');
                return;
        }
        var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{7,200}$/;
        if (!password.match(passw)) Session.alert('Passord must contain at least a number, an uppercase letter and a lowercase letter.');
};

export const validateDate = (_date) => {
        const isValidDate = Date.parse(_date);

        if (isNaN(isValidDate)) Session.alert('Date is invalid. Please select a valid date');

};


export const validatePhone = (_phone) => {
        if (!_phone) {
                Session.alert('Phone is empty. Please enter a phone number.');
                return;
        }
        // var phoneno = /^[+][1-9][0-9]{6,14}$/g;
        var phoneno = /^([+][1-9]|[1-9]|[0][1-9])[0-9]{6,14}$/;
        if (!_phone.match(phoneno)) Session.alert('Phone number is invalid (' + _phone + '). Please type a valid phone number');

};
